import React from "react";

import {
  formatCurrency,
  formatGainCurrency
} from "./CalculatorLogic";
import {colors} from "nxtconstants";
import {
  DataTable,
  LegendContainer,
  LegendItem,
  LegendLabel,
  LegendSwatch,
  MobileSummaryCard,
  MobileSummaryHighlight,
  MobileSummaryRow,
  MobileTabButton,
  MobileTabContainer,
  SummaryBar,
  SummaryItem,
  SummaryLabel,
  SummaryValue,
  TableWrapper,
  TooltipTotalRow,
  ViewToggleButton,
  ViewToggleContainer
} from "./CalculatorStyle";
import {
  TooltipContainer,
  TooltipRow,
  TooltipTitle,
  TooltipValue
} from "components/ClientHome/CalculatorStyle";

export const MobileTabToggle = ({activeTab, onChange}) => (
  <MobileTabContainer>
    <MobileTabButton
      active={activeTab === "input"}
      type="button"
      onClick={() => onChange("input")}
    >
      Input
    </MobileTabButton>
    <MobileTabButton
      active={activeTab === "result"}
      type="button"
      onClick={() => onChange("result")}
    >
      Result
    </MobileTabButton>
  </MobileTabContainer>
);

export const SummaryCards = ({
  futureValue,
  totalInvested,
  gain
}) => (
  <>
    <SummaryBar>
      <SummaryItem>
        <SummaryLabel>Your Future Value</SummaryLabel>
        <SummaryValue>{formatCurrency(futureValue)}</SummaryValue>
      </SummaryItem>
      <SummaryItem>
        <SummaryLabel>Invested Amount</SummaryLabel>
        <SummaryValue>{formatCurrency(totalInvested)}</SummaryValue>
      </SummaryItem>
      <SummaryItem>
        <SummaryLabel>Gain</SummaryLabel>
        <SummaryValue variant="gain">{formatGainCurrency(gain)}</SummaryValue>
      </SummaryItem>
    </SummaryBar>

    <MobileSummaryCard>
      <MobileSummaryHighlight>
        <span>Your Future Value</span>
        <span>{formatCurrency(futureValue)}</span>
      </MobileSummaryHighlight>
      <MobileSummaryRow>
        <span>Invested Amount</span>
        <span>{formatCurrency(totalInvested)}</span>
      </MobileSummaryRow>
      <MobileSummaryRow>
        <span>Gain</span>
        <span>{formatCurrency(gain)}</span>
      </MobileSummaryRow>
    </MobileSummaryCard>
  </>
);

export const ViewToggle = ({activeView, onChange}) => (
  <ViewToggleContainer>
    <ViewToggleButton
      active={activeView === "graph"}
      type="button"
      onClick={() => onChange("graph")}
    >
      Graph
    </ViewToggleButton>
    <ViewToggleButton
      active={activeView === "table"}
      type="button"
      onClick={() => onChange("table")}
    >
      Table
    </ViewToggleButton>
  </ViewToggleContainer>
);

export const YearlyTable = ({yearlyData}) => (
  <TableWrapper>
    <DataTable>
      <thead>
        <tr>
          <th>Year</th>
          <th>Total Invested</th>
          <th>Gain</th>
          <th>Future Value</th>
        </tr>
      </thead>
      <tbody>
        {yearlyData.map((row) => (
          <tr key={row.year}>
            <td>Year {row.year}</td>
            <td>{formatCurrency(row.investedAmount)}</td>
            <td>{formatCurrency(row.gain)}</td>
            <td>{formatCurrency(row.futureValue)}</td>
          </tr>
        ))}
      </tbody>
    </DataTable>
  </TableWrapper>
);

export const ChartHoverInfo = ({active, payload, label}) => {
  if (!active || !payload || !payload.length) {
    return null;
  }

  const investment = payload[0].value;
  const returns = payload[1].value;

  return (
    <TooltipContainer>
      <TooltipTitle>{label}</TooltipTitle>
      <TooltipRow color={colors.primary}>
        Investment <TooltipValue>{formatCurrency(investment)}</TooltipValue>
      </TooltipRow>
      <TooltipRow color={colors.chartAccentText}>
        Estimated Return <TooltipValue>{formatCurrency(returns)}</TooltipValue>
      </TooltipRow>
      <TooltipTotalRow>
        Future Value <TooltipValue>{formatCurrency(investment + returns)}</TooltipValue>
      </TooltipTotalRow>
    </TooltipContainer>
  );
};

export const ChartLabel = ({payload = []}) => (
  <LegendContainer>
    {payload.map((entry) => (
      <LegendItem key={entry.value}>
        <LegendSwatch color={entry.color} />
        <LegendLabel>{entry.value}</LegendLabel>
      </LegendItem>
    ))}
  </LegendContainer>
);
